import './index.css';
import './styles_REMOVE_ONLY.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { getRemoteHost } from '@vse/api/api_request';
import { getApiVersion } from '@vse/api/machinemotion';
import { setupJqueryForMachineLogicReactComponents } from '@vse-legacy/machinelogic_react_components_support';

// Javascript
// I did not question these imports, I merely made them work with webpack
// These scripts mess with the window object to set variables used by vse
import '@src/style/style';
import '@src/Main/main';

import { applyMachineLogicStyles } from '@src/style';
applyMachineLogicStyles();

// This attaches an method to jquery that lets jquery to be marked with a data attribute that is
// used to identify machinelogic react components.
setupJqueryForMachineLogicReactComponents();

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);

// NOTE: Big hack! We are checking if we are in an iframe so that we can provide a zoom
// for path-following-vention-io when it is hosted by rails. Don't do drugs!
if (window.location !== window.parent.location && rootElement !== null) {
  rootElement.className += ' root-in-iframe';
}

// We want to expose the remote host to Cypress
// It doesn't feel nice, but I don't know any better
// If you can improve this, please do!
(window as any).pendantToCypress = {
  getRemoteHost,
  getApiVersion,
};
